module.exports = __webpack_public_path__ + "img/[饥饿].676057dd.svg";